import SectionTitle from "components/Pages/Purchases_new/components/SectionTitle";
import {
  CurrencyE,
  PaymentTypeE,
  PurchaseStepE,
} from "components/Pages/Purchases_new/models/enums";
import { useCallback, type Dispatch, type SetStateAction } from "react";
import Button from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./paymentForm.module.scss";
import s from "../../paymentMethodSection.module.scss";
import { useAppSelector } from "store/hooks";
import { selectBillingData } from "components/Pages/Purchases_new/store/purchasesSelectors";
import fetchPaymentUrl from "components/Reusable/ThanksActionButton/api/fetchPaymentUrl";
import {
  DEFAULT_COUNTRY_ID,
  TRANSACTION_PURCHASE_TYPE,
} from "components/Reusable/ThanksActionButton/constants/constants";
import useCurrentCurrency from "components/Pages/Plans/Utils/useCurrentCurrency";
import useCreditCard from "components/Pages/Purchases_new/hooks/useCreditCard";
import { useLocation } from "react-router-dom";

interface PaymentFormI {
  iframeUrl: string;
  isFailed: boolean;
  setIsFailed: Dispatch<SetStateAction<boolean>>;
  setStep: Dispatch<SetStateAction<PurchaseStepE>>;
  transactionAmount: number;
  setIframeUrl: Dispatch<SetStateAction<string>>;
}

const PaymentForm = ({
  iframeUrl,
  isFailed,
  setIsFailed,
  setStep,
  transactionAmount,
  setIframeUrl,
}: PaymentFormI) => {
  const { paymentType } = useCreditCard();
  const location = useLocation();
  const currency = useCurrentCurrency();
  const currentCurrency = CurrencyE[currency as keyof typeof CurrencyE];
  const billingData = useAppSelector(selectBillingData);

  const { getTextByKey } = useContent();

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const lastSegment = pathSegments.pop();
  const secondLastSegment = pathSegments.pop();

  const currentPage =
    lastSegment === "home"
      ? lastSegment
      : `${secondLastSegment}/${lastSegment}`;

  const handleTryPaymentAgain = useCallback(async () => {
    setIsFailed(false);

    const transactionData = {
      TransactionEmail: billingData?.email.trim(),
      TransactionFirstName: billingData?.firstName.trim(),
      TransactionLastName: billingData?.lastName.trim(),
      TransactionPhone: billingData?.phone.trim() || "123123",
      TransactionCountryId: DEFAULT_COUNTRY_ID,
      TransactionPriceDisplayedToUser: transactionAmount,
      TransactionPurchaseProvider: paymentType,
      TransactionPurchaseType: TRANSACTION_PURCHASE_TYPE,
      TransactionUserIsAuthenticated: true,
      TransactionCurrency: currentCurrency,
      getOnlyIframe: true,
      TransactionPackageName: TRANSACTION_PURCHASE_TYPE,
      TransactionUserPassword: "123123",
      UrlResponse: `${currentPage}/payment-success`,
    };

    const paymentUrl = await fetchPaymentUrl(transactionData);

    if (paymentUrl) {
      if (paymentType === PaymentTypeE.CREDIT_CARD) {
        setStep(PurchaseStepE.THIRD_PAYMENT_STEP);
        setIframeUrl(paymentUrl);
      } else if (paymentType === PaymentTypeE.PAYPAL) {
        window.open(paymentUrl);
      }
    }
  }, [
    billingData?.email,
    billingData?.firstName,
    billingData?.lastName,
    billingData?.phone,
    currentCurrency,
    currentPage,
    paymentType,
    setIframeUrl,
    setIsFailed,
    setStep,
    transactionAmount,
  ]);

  return (
    <div className={`${styles.purchaseIframeContainer}`}>
      <SectionTitle
        titleTextKey={
          !isFailed
            ? "purchase-payment-check-out"
            : "purchase-payment-check-out-failed"
        }
        step={PurchaseStepE.THIRD_PAYMENT_STEP}
        className={`${s.customTitle} `}
      />

      {isFailed ? (
        <div className={styles.tryAgainBtnWrap}>
          <Button
            onClick={handleTryPaymentAgain}
            className={styles.tryAgainBtn}
          >
            {getTextByKey("try-again")}
          </Button>
        </div>
      ) : iframeUrl ? (
        <div className={styles.iframeWrapper}>
          <iframe
            title="JumboMail Payment"
            src={iframeUrl}
            allowFullScreen
            className={styles.paymentIframe}
          />
        </div>
      ) : null}
    </div>
  );
};
export default PaymentForm;
